import { useEffect, useState } from 'react';
import api from '../../utils/api';
import { FileText, DollarSign, Newspaper, Library as LibraryIcon, Users, TrendingUp, CalendarDays } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({ minutes: 0, financial: 0, news: 0, library: 0, agendas: 0 });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [minutes, financial, news, library, agendas] = await Promise.all([
        api.get('/minutes'),
        api.get('/financial-statements'),
        api.get('/news'),
        api.get('/library'),
        api.get('/agendas')
      ]);
      setStats({
        minutes: minutes.data.length,
        financial: financial.data.length,
        news: news.data.length,
        library: library.data.length,
        agendas: agendas.data.length
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const statsCards = [
    { label: 'Minutes', value: stats.minutes, icon: FileText, color: 'bg-blue-500' },
    { label: 'Financial Docs', value: stats.financial, icon: DollarSign, color: 'bg-green-500' },
    { label: 'News Articles', value: stats.news, icon: Newspaper, color: 'bg-orange-500' },
    { label: 'Library Items', value: stats.library, icon: LibraryIcon, color: 'bg-purple-500' },
    { label: 'Agendas', value: stats.agendas, icon: CalendarDays, color: 'bg-indigo-500' },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="page-header">Admin Dashboard</h1>
        <p className="text-slate-600">Manage your AHSGA portal content</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {statsCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.label} className="card">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-600 mb-1">{stat.label}</p>
                  <p className="text-3xl font-serif font-bold text-slate-900">{stat.value}</p>
                </div>
                <div className={`${stat.color} p-3 rounded-lg`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="card">
        <h2 className="section-title mb-4">Quick Stats</h2>
        <p className="text-slate-600">Welcome to your admin dashboard. Use the sidebar to manage content.</p>
      </div>
    </div>
  );
};

export default Dashboard;